import React from 'react';
import SEO from './SEO';
import styleClasses from './css/AboutUs.module.scss';

const PrivacyPolicy = () => {
  return (
    <>
      <SEO title={'개인정보처리방침'} />
      <div className={styleClasses.aboutUs}>
        <div className={styleClasses.inner}>
          <div className={styleClasses.hero}>
            <h1 className={styleClasses.title}>개인정보처리방침</h1>
          </div>
          <div className={styleClasses.content}>
            <section>
              <h3>제1조 (목적)</h3>
              <p>
                이 개인정보처리방침은 뮤지직(Musizic)(이하 "회사")이 운영하는 플랫폼에서 제공하는 <strong>뮤지카드(MusiCard) 서비스</strong>(이하 "서비스")를 이용하는 회원의 개인정보를 보호하고, 관련 법령을 준수하기 위해 마련되었습니다. 본 방침은 회원이 제공하는 개인정보가 어떻게 수집, 이용, 보호되는지를 설명합니다.
              </p>
              <h3>제2조 (수집하는 개인정보의 항목 및 수집 방법)</h3>
              <ol>
                <li>
                  <strong>필수 수집 정보</strong>: 회원가입 및 서비스 이용을 위해 다음 정보를 필수로 수집합니다.
                  <ul>
                    <li>이메일 주소, 비밀번호 (SNS 로그인 이용 시, 해당 플랫폼에서 제공하는 최소한의 정보)</li>
                    <li>이름 또는 닉네임</li>
                    <li>서비스 이용 기록 및 접속 로그</li>
                    <li>IP 주소 및 쿠키 정보</li>
                  </ul>
                </li>
                <li>
                  <strong>선택적 수집 정보</strong>: 회원이 제공하는 경우에만 수집하며, 마케팅 및 맞춤형 서비스 제공을 위해 활용됩니다.
                  <ul>
                    <li>프로필 이미지</li>
                    <li>연락처 및 소셜미디어 계정</li>
                    <li>결제 정보 (유료 서비스 이용 시)</li>
                  </ul>
                </li>
                <li>
                  <strong>자동 수집 정보</strong>: 서비스 이용 과정에서 자동으로 수집되는 정보
                  <ul>
                    <li>기기 정보(운영체제, 브라우저 유형)</li>
                    <li>방문 기록 및 이용 패턴</li>
                  </ul>
                </li>
              </ol>
              <h3>제3조 (개인정보의 수집 및 이용 목적)</h3>
              <ol>
                <li>회원 관리: 회원가입, 본인 확인, 계정 보안 관리</li>
                <li>서비스 제공: 뮤지카드 제작, 저장, 공유 기능 제공</li>
                <li>고객 지원: 문의 응대, 문제 해결, 공지사항 전달</li>
                <li>서비스 개선 및 분석: 이용 패턴 분석, 기능 개선</li>
                <li>마케팅 및 광고 활용 (선택 동의 시): 이벤트 안내, 프로모션 제공</li>
              </ol>
              <h3>제4조 (개인정보의 보관 및 파기)</h3>
              <ol>
                <li>
                  <strong>보관 기간</strong>: 회원 탈퇴 또는 목적 달성 시까지 보관하며, 관련 법령에 따라 일정 기간 보관이 필요한 경우 예외적으로 보관합니다.
                  <ul>
                    <li>계약 또는 청약철회 기록: 5년 (전자상거래법)</li>
                    <li>대금결제 및 공급 기록: 5년 (전자상거래법)</li>
                    <li>소비자 불만 및 분쟁 기록: 3년 (전자상거래법)</li>
                  </ul>
                </li>
                <li>
                  <strong>파기 절차 및 방법</strong>: 보관 기간이 지난 개인정보는 지체 없이 안전하게 삭제됩니다.
                  <ul>
                    <li>전자적 파일 형태: 복구할 수 없도록 완전 삭제</li>
                    <li>서면 문서 형태: 물리적 파쇄</li>
                  </ul>
                </li>
              </ol>
              <h3>제5조 (개인정보의 제3자 제공 및 위탁)</h3>
              <ol>
                <li>
                  회사는 회원의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 법령에 따라 요구되는 경우 제공될 수 있습니다.
                </li>
                <li>
                  원활한 서비스 운영을 위해 다음과 같이 개인정보 처리를 위탁할 수 있습니다.
                  <ul>
                    <li>결제 처리: 결제 대행사 (예: PG사)</li>
                    <li>데이터 저장 및 서버 운영: 클라우드 서비스 제공 업체</li>
                    <li>고객 상담: 고객 지원 서비스 업체</li>
                  </ul>
                </li>
                <li>위탁 계약 시, 개인정보 보호 조항을 포함하여 관리·감독을 철저히 합니다.</li>
              </ol>
              <h3>제6조 (회원의 권리 및 행사 방법)</h3>
              <ol>
                <li>
                  회원은 자신의 개인정보에 대해 다음과 같은 권리를 가집니다.
                  <ul>
                    <li>개인정보 조회 및 수정 요청</li>
                    <li>계정 삭제 및 개인정보 처리 정지 요청</li>
                    <li>동의 철회 및 마케팅 거부 요청</li>
                  </ul>
                </li>
                <li>회원은 플랫폼 내 설정 또는 고객센터를 통해 위 권리를 행사할 수 있습니다.</li>
              </ol>
              <h3>제7조 (쿠키 사용 및 거부 방법)</h3>
              <ol>
                <li>회사는 맞춤형 서비스 제공을 위해 쿠키(Cookie)를 사용합니다.</li>
                <li>회원은 브라우저 설정을 통해 쿠키 저장을 거부하거나 삭제할 수 있습니다.</li>
              </ol>
              <h3>제8조 (개인정보 보호를 위한 안전 조치)</h3>
              <ol>
                <li>기술적 조치: 데이터 암호화, 방화벽 및 침입 탐지 시스템 적용</li>
                <li>관리적 조치: 개인정보 접근 제한, 담당자 교육</li>
                <li>물리적 조치: 서버 접근 통제, 보안 시스템 운영</li>
              </ol>
              <h3>제9조 (개인정보 보호책임자 및 문의처)</h3>
              <p>
                회사는 개인정보 보호를 위한 책임자를 지정하고 있으며, 개인정보 관련 문의는 아래 연락처로 접수할 수 있습니다.
              </p>
              <p>개인정보 보호책임자: 김예원</p>
              <p>이메일: contact@musizic.com</p>
              <h3>제10조 (개인정보처리방침 변경 및 공지)</h3>
              <ol>
                <li>
                  본 방침은 법령 및 서비스 정책 변경에 따라 개정될 수 있으며, 변경 사항은 최소 7일 전(중요한 변경 사항은 30일 전) 공지됩니다.
                </li>
                <li>
                  회원이 변경된 방침에 동의하지 않는 경우, 서비스 이용을 중단하고 계정 삭제를 요청할 수 있습니다.
                </li>
              </ol>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;